import * as React from 'react'
import {useSelector} from 'react-redux'

import detailsSlice from '../detailsSlice'
import {selectBrowser, selectBrowserVersion} from '../selectors'
import {useInProductSupportDispatch} from '../store'
import AdditionalTextInput from './AdditionalTextInput'

const WebAdditionalFields: React.FC = () => {
  const dispatch = useInProductSupportDispatch()

  const browser = useSelector(selectBrowser)
  const browserVersion = useSelector(selectBrowserVersion)

  const updateBrowser = (newBrowser: string): void => {
    dispatch(detailsSlice.actions.updateDetails({browser: newBrowser}))
  }

  const updateBrowserVersion = (newBrowserVersion: string): void => {
    dispatch(
      detailsSlice.actions.updateDetails({browserVersion: newBrowserVersion})
    )
  }

  return (
    <>
      <AdditionalTextInput
        name="Browser"
        value={browser}
        onChange={updateBrowser}
      />
      <AdditionalTextInput
        name="Browser version"
        value={browserVersion}
        onChange={updateBrowserVersion}
      />
    </>
  )
}

export default WebAdditionalFields
